import { createReducer } from '../../store.model';

import { ActionType } from './power-bi.action';
import { defaultState, PowerBiState } from './power-bi.state';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';

const { reducer, builder } = createReducer<ActionType, PowerBiState>(
    defaultState(),
);

builder
    .add<Reload>(ActionType.POWER_BI__RELOAD, reloadReducer)
    .add<ReloadResult>(ActionType.POWER_BI__RELOAD_RESULT, reloadResultReducer);

export const powerBiReducer = reducer;
